import React from "react";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import { Col, Row } from "react-bootstrap";
import Dropzone from "../../../components/carousel/Dropzone.jsx";

export default function ImageSection({ image, onDrop, onDelete, onDropCSV }) {
    return (
        <>
            <Row className="mb-3">
                <Col md={6}>
                    <Dropzone onDrop={onDrop} title="Upload Challenge Image" accept="image/*" />
                </Col>
            </Row>

            {image.length > 0 && (
                <Row className="mb-3 align-items-center">
                    <Col xs={6} md={4}>
                        <Image src={image[0].src} fluid />
                    </Col>
                    <Col md={4}>
                        <Button variant="outline-danger" onClick={onDelete}>Delete Image</Button>
                    </Col>
                </Row>
            )}

            <Row className="mb-3">
                <Col md={6}>
                    <Dropzone
                        onDrop={onDropCSV}
                        title="Upload CSV"
                        accept=".csv, application/vnd.ms-excel, text/csv"
                    />
                </Col>
            </Row>
        </>
    );
}
